import React from 'react'
import Navbar from '../homepage/components/navbar/Navbar'
import Footer from '../homepage/components/Footer/Footer'

export default function PastCouncil() {
  return (
    <div>
      <Navbar/>
      <div className='team-page'>
        <h1>OUR PAST COUNCIL</h1>
        <div className='team-page-section'>
            <h2>2022-2023</h2>
            <div className='team-page-cards'>
                
            </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}
